// Types
import { TCustomTheme } from '@mgm/common/theme';

// Utils
import { formatNumber } from '../../../utils/helpers';

const salesChartOptions = (theme: TCustomTheme, currencyMark: string) => ({
  colors: [theme.palette.primary.main],
  chart: { sparkline: { enabled: true } },
  plotOptions: { bar: { columnWidth: '68%', borderRadius: 2 } },
  labels: ['1', '2', '3', '4', '5', '6', '7', '8'],
  tooltip: {
    x: { show: false },
    y: {
      formatter: (seriesName: string) => `${formatNumber(seriesName)} ${currencyMark}`,
      title: {
        formatter: () => '',
      },
    },
    marker: { show: false },
  },
});

const ordersChartOptions = (theme: TCustomTheme) => ({
  colors: [theme.palette.chart.blue[0]],
  chart: { sparkline: { enabled: true } },
  plotOptions: { bar: { columnWidth: '68%', borderRadius: 2 } },
  labels: ['1', '2', '3', '4', '5', '6', '7', '8'],
  tooltip: {
    x: { show: false },
    y: {
      formatter: (seriesName: string) => formatNumber(seriesName),
      title: {
        formatter: () => '',
      },
    },
    marker: { show: false },
  },
});

const expensesChartOptions = (theme: TCustomTheme) => ({
  colors: [theme.palette.chart.red[0]],
  chart: { sparkline: { enabled: true } },
  plotOptions: { bar: { columnWidth: '68%', borderRadius: 2 } },
  labels: ['1', '2', '3', '4', '5', '6', '7', '8'],
  tooltip: {
    x: { show: false },
    y: {
      formatter: (seriesName: string) => formatNumber(seriesName),
      title: {
        formatter: () => '',
      },
    },
    marker: { show: false },
  },
});

export {
  salesChartOptions,
  ordersChartOptions,
  expensesChartOptions,
};
